// Facebook Pixel utility — injects the FB Pixel script and exposes a typed tracker.
// Pixel ID: 1545009850674181
// Fails silently if the script is blocked (ad blocker, sandboxed iframe, CSP, offline).

export const FB_PIXEL_ID = '1545009850674181'

declare global {
  interface Window {
    fbq?: any
    _fbq?: any
  }
}

let initialized = false

export function initFacebookPixel(): void {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized || window.fbq) {
    initialized = true
    return
  }

  try {
    // Standard Meta Pixel base code, hardened to never throw out of this module.
    ;(function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return
      const n: any = (f.fbq = function () {
        try {
          // eslint-disable-next-line prefer-rest-params
          n.callMethod
            ? n.callMethod.apply(n, arguments)
            : n.queue.push(arguments)
        } catch {
          /* swallow */
        }
      })
      if (!f._fbq) f._fbq = n
      n.push = n
      n.loaded = true
      n.version = '2.0'
      n.queue = []

      const t = b.createElement(e) as HTMLScriptElement
      t.async = true
      t.src = v
      // Prevent uncaught "Script error." from cross-origin failures
      // (ad blockers, sandboxed previews, network errors).
      t.onerror = () => {
        /* silently ignore — pixel just won't fire */
      }

      const s = b.getElementsByTagName(e)[0]
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s)
      } else {
        b.head.appendChild(t)
      }
    })(
      window,
      document,
      'script',
      'https://connect.facebook.net/en_US/fbevents.js',
    )

    if (window.fbq) {
      window.fbq('init', FB_PIXEL_ID)
      window.fbq('track', 'PageView')
    }

    // <noscript> fallback pixel — wrapped in try/catch in case body isn't ready
    if (document.body) {
      const noscript = document.createElement('noscript')
      const img = document.createElement('img')
      img.height = 1
      img.width = 1
      img.style.display = 'none'
      img.src = `https://www.facebook.com/tr?id=${FB_PIXEL_ID}&ev=PageView&noscript=1`
      noscript.appendChild(img)
      document.body.appendChild(noscript)
    }

    initialized = true
  } catch {
    // Never let pixel setup break the app.
    initialized = true
  }
}

type StandardEvent =
  | 'PageView'
  | 'ViewContent'
  | 'AddToCart'
  | 'InitiateCheckout'
  | 'AddPaymentInfo'
  | 'Purchase'
  | 'Lead'
  | 'CompleteRegistration'
  | 'Contact'

export function trackEvent(
  event: StandardEvent,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  try {
    if (params) {
      window.fbq('track', event, params)
    } else {
      window.fbq('track', event)
    }
  } catch {
    /* swallow — never break the UI for analytics */
  }
}

export function trackCustom(
  event: string,
  params?: Record<string, unknown>,
): void {
  if (typeof window === 'undefined' || typeof window.fbq !== 'function') return
  try {
    if (params) {
      window.fbq('trackCustom', event, params)
    } else {
      window.fbq('trackCustom', event)
    }
  } catch {
    /* swallow */
  }
}
